module.exports = __webpack_public_path__ + "static/media/Amol.a85f47c4.jpeg";